import type { SignDocument } from "../Models/Domain";

import useSignDocuments from "../Store";

import { getSignDocument } from "@/Services/TherapyApi/SignDocuments";

import { isApiError } from "@/Services/Api/Typeguards/isApiError";

import SignDocumentTransformer from "@/Modules/Transformers/SignDocument";
import { hasValue } from "@/Utils/Objects";

async function fetchSignDocumentActionHandler(uuid: string): Promise<SignDocument | undefined> {
  const signDocumentsStore = useSignDocuments();

  signDocumentsStore.isLoading = true;

  let document = await getSignDocument(uuid).catch(() => undefined);

  if (!hasValue(document) || isApiError(document)) {
    document = undefined;
  }

  signDocumentsStore.isLoading = false;

  if (!hasValue(document)) return undefined;

  return SignDocumentTransformer.toDomain(document);
}

export default fetchSignDocumentActionHandler;
